import React from "react";
import { useQuotesHook } from "../API";
import Loading from "./Loading";

const Quote = () => {
  const { state } = useQuotesHook();

  if (!state) return <Loading />;

  return (
    <section className="container quote">
      <figure className="quote__content">
        <blockquote cite="https://github.com/lukePeavey/quotable">
          {state.content}
        </blockquote>
        <figcaption>{state.author}</figcaption>
      </figure>
    </section>
  );
};

export default Quote;
